module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_preference/high_protein--xxs@1x-0b734f9813bc9f4043549d505294813d.png";